// redux
import { useSelector } from "react-redux";
// react router
import { useLocation, useNavigate } from "react-router-dom";
// css
import classes from "./PlanItem.module.css";
// classnames
import classNames from "classnames";
// services
import { GetPaymentTokenWeb } from "../../services/subscriptions";

const PlanItem = (props) => {
  // redux
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  // react router
  const location = useLocation();
  const navigate = useNavigate();
  // props
  const {
    planPrice,
    Currency,
    Monthly,
    Quarterly,
    Yearly,
    planId,
    MostUsedPlan,
  } = props;

  // handlers
  const GetPaymentTokenWebHandler = async () => {
    if (!isAuthenticated) {
      navigate("/account", { state: location, replace: false });
    } else {
      var planPaymentToken = await GetPaymentTokenWeb(planId);
      // var planPaymentToken =
      //   "ZXlKaGJHY2lPaUpJVXpVeE1pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SjFjMlZ5WDJsa0lqb3hNVGd3TXpNMUxDSmhiVzkxYm5SZlkyVnVkSE1pT2pFeU9USXdMQ0pqZFhKeVpXNWplU0k2SWtWSFVDSXNJbWx1ZEdWbmNtRjBhVzl1WDJsa0lqb3pNemcwT0RnMkxDSnZjbVJsY2w5cFpDSTZNall6TWpZeU9ETTNMQ0ppYVd4c2FXNW5YMlJoZEdFaU9uc2labWx5YzNSZmJtRnRaU0k2SWxWelpYSWlMQ0pzWVhOMFgyNWhiV1VpT2lKQlpHMXBiaUlzSW5OMGNtVmxkQ0k2SWs1Qklpd2lZblZwYkdScGJtY2lPaUpPUVNJc0ltWnNiMjl5SWpvaVRrRWlMQ0poY0dGeWRHMWxiblFpT2lKT1FTSXNJbU5wZEhraU9pSk9RU0lzSW5OMFlYUmxJam9pVGtFaUxDSmpiM1Z1ZEhKNUlqb2lUa0VpTENKbGJXRnBiQ0k2SW1Ga2JXbHVRR0ZrYldsdUxtTnZiU0lzSW5Cb2IyNWxYMjUxYldKbGNpSTZJakl3TVRJek5EVTJOemc1TUNJc0luQnZjM1JoYkY5amIyUmxJam9pVGtFaUxDSmxlSFJ5WVY5a1pYTmpjbWx3ZEdsdmJpSTZJazVCSW4wc0lteHZZMnRmYjNKa1pYSmZkMmhsYmw5d1lXbGtJanBtWVd4elpTd2laWGgwY21FaU9udDlMQ0p6YVc1bmJHVmZjR0Y1YldWdWRGOWhkSFJsYlhCMElqcG1ZV3h6WlN3aVpYaHdJam94TnpNeE1qWTNPRFl4TENKd2JXdGZhWEFpT2lJMUxqRTRNaTR4Tnk0eE16VWlmUS44Z0FGWXdJVi13YXZDU2pMZm1XMVg0SHFza3JINGhXQ1E3R1hpY2oyZndCWkNFWjZYeW90WElpNW5SVDdXUHVyckhTcnhTLXlzNDBMY3lpODhURW91dw==";
      if (planPaymentToken.data.data != null) {
        window.open(
          "https://accept.paymob.com/api/acceptance/iframes/730880?payment_token=" +
            planPaymentToken.data.data,
          "_self"
        );
        // window.open(
        //   "https://accept.paymob.com/api/acceptance/iframes/730880?payment_token=" +
        //     planPaymentToken,
        //   "_self"
        // );
      }
    }
  };

  return (
    <div
      className={`${
        MostUsedPlan ? classes.Plan_IsMostUsed : classes.Plan_Contanier
      }`}
    >
      <div className={classes.Plan_Container}>
        {MostUsedPlan ? (
          <div className={classes.MostUsedPlan}>الأكثر شهرة</div>
        ) : null}
        <div className={classes.Plan_Title}>
          {Monthly ? (
            <h1>اشتراك شهري</h1>
          ) : Quarterly ? (
            <h1>اشتراك 6 شهور</h1>
          ) : Yearly ? (
            <h1>اشتراك سنوي</h1>
          ) : null}

          <h6>
            <span className={classes.Plan_Price_Right}>{planPrice}</span>
            <span>{Currency}</span>
          </h6>
        </div>
        <ul>
          <li>
            <span>آلاف الكتب مقابل </span>
            <span className={classes.Margin_Left}>{Currency}</span>
            <span className={classes.Margin_Left}>{planPrice}</span>
            {Monthly ? (
              <span>شهرياً فقط</span>
            ) : Quarterly ? (
              <span>لمدة 6 شهور فقط</span>
            ) : Yearly ? (
              <span>سنويا فقط</span>
            ) : null}
          </li>
          <li>
            تحميل وقراءة كل الكتب بلا حدود بسعر الكتاب الورقي الواحد اقرأ أينما
            كنت دون الحاجة إلى الإنترنت
          </li>
          <li>بإمكانك إلغاء الاشتراك في أي لحظة</li>
        </ul>
        <button
          className={classes.Plan_Btn}
          onClick={GetPaymentTokenWebHandler}
        >
          اشترك الان
        </button>
      </div>
    </div>
  );
};

export default PlanItem;
